import { map } from 'rxjs/operators';
import { Injectable, Optional, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { PageTemplate } from '../models/page-layout.model';
import { EDIT_LIBRARY_OPTIONS } from '../tokens/edit-library-options.token';
import { EditLibraryOptions } from '../models/edit-library-options.model';
import { cloneDeep } from 'lodash';

@Injectable()
export class PageLayoutService {
    private pageLayouts: PageTemplate[];
    private baseUrl: string;

    constructor(private http: HttpClient, @Optional() @Inject(EDIT_LIBRARY_OPTIONS) private editLibraryOptions: EditLibraryOptions) {
        this.baseUrl = this.configureUrl();
    }

    configureUrl() {
        // let dataSourceUrl: string = 'https://component-registry.dev.bnymellon.net/registry';
        let dataSourceUrl: string = null;
        if (this.editLibraryOptions && this.editLibraryOptions.layoutDefinitionURL) {
            dataSourceUrl = this.editLibraryOptions.layoutDefinitionURL;
        }
        return dataSourceUrl;
    }

    retrieveLayoutTemplates(): any {
        if (this.pageLayouts) {   // Only fetch once from service
            return of(cloneDeep(this.pageLayouts));
        } else if (this.baseUrl) {
            return this.http.get(this.baseUrl + '/pageLayouts').pipe(
                map((data: any) => {
                    this.pageLayouts = data.response;
                    return cloneDeep(this.pageLayouts);
                })
            );
        } else {
            return of(null);
        }
    }
}
